import {Component, OnInit, ViewChild} from '@angular/core';
import {Router, RouterOutlet} from '@angular/router';
import {fadeInAnimation} from '../../../../animations/fadeInAnimation';
import {slideInOutAnimation} from '../../../../animations/slideInAnimation';
import {AuthorizationService} from '../../../../services/authorization.service';
import {MatDialog} from '@angular/material/dialog';


@Component({
    selector: 'app-sidenav',
    templateUrl: './sidenav.component.html',
    styleUrls: ['./sidenav.component.css'],
    animations: [
        slideInOutAnimation
        // animation triggers go here
    ]
})
export class SidenavComponent implements OnInit {

    /* @ViewChild('right_sidenav') right_sidenav;*/
    openSidebar = false;

    admin: Array<{ title: String, subtitle: String, path: String, order: String, class: String, icon: String, icon_type: String, children: Array<{ title: String, sub_path: String, icon: String, }>, permission: String }> = [];


    constructor(private router: Router,
                private dialog: MatDialog,
                public authorize: AuthorizationService) {

        this.admin.push({
            title: 'Dashboard',
            subtitle: '',
            path: '/admin/dashboard',
            order: '1',
            class: '',
            icon: 'fa fa-home',
            icon_type: 'icon',
            children: null,
            permission: 'view_dashboard'
        });
        this.admin.push({
            title: 'Stores',
            subtitle: '',
            path: '/admin/stores',
            order: '1',
            class: '',
            icon: 'assets/store.png',
            icon_type: 'image',
            children: null,
            permission: 'manage_all_stores'
        });

        this.admin.push({
            title: 'Aramex',
            subtitle: '',
            path: '/admin/orders',
            order: '1',
            class: '',
            icon: 'assets/aramex.webp',
            icon_type: 'image',
            children: null,
            permission: 'manage_aramex_orders',
            // faIcon: faBoxes
        });


        this.admin.push({
            title: 'Users',
            subtitle: '',
            path: '/admin/users',
            order: '1',
            class: '',
            icon: 'fa fa-users',
            icon_type: 'icon',
            children: null,
            permission: 'manage_all_users'
        });


        this.admin.push({
            title: 'Sliders',
            subtitle: '',
            path: '/admin/slider_manager',
            order: '1',
            class: '',
            icon: 'fa fa-image',
            icon_type: 'icon',
            children: null,
            permission: 'manage_sliders'
        });

        this.admin.push({
            title: 'Content',
            subtitle: '',
            path: '/admin/pages',
            order: '1',
            class: '',
            icon: 'fa fa-file-text',
            icon_type: 'icon',
            children: null,
            permission: 'manage_content'
        });

        this.admin.push({
            title: 'Marketing',
            subtitle: '',
            path: '/admin/marketing-campaigns',
            order: '1',
            class: '',
            icon: 'fa fa-bullhorn',
            icon_type: 'icon',
            children: null,
            permission: 'view_settings'
        });


        this.admin.push({
            title: 'Virtual Panels',
            subtitle: '',
            path: '/admin/virtual_panels',
            order: '1',
            class: '',
            icon: 'fa fa-globe',
            icon_type: 'icon',
            children: null,
            permission: 'manage_vpanel'
        });

        this.admin.push({
            title: 'Settings',
            subtitle: '',
            path: '/admin/settings_general',
            order: '1',
            class: '',
            icon: 'fa fa-gear',
            icon_type: 'icon',
            children: null,
            permission: 'view_settings'
        });

    }

    prepareRoute(outlet: RouterOutlet) {

        return outlet && outlet.activatedRouteData && outlet.activatedRouteData['animation'];
    }


    ngOnInit() {
    }

}
